import { doc, getDoc, setDoc } from 'firebase/firestore'
import type { Settings } from '../settingsStorage'
import { getFirestoreInstance } from '../firebase'
import { getCurrentPlaceId } from '../placeConfig'

const settingsCacheByPlace: Record<string, Partial<Settings> | null> = {}

function settingsDocRef(placeId: string) {
  return doc(getFirestoreInstance(), 'places', placeId, 'settings', 'app')
}

export async function primeSettingsCache(): Promise<void> {
  const placeId = getCurrentPlaceId()
  const snap = await getDoc(settingsDocRef(placeId))
  settingsCacheByPlace[placeId] = snap.exists() ? (snap.data() as Partial<Settings>) : null
}

export function getSettingsCache(): Partial<Settings> | null {
  const placeId = getCurrentPlaceId()
  return settingsCacheByPlace[placeId] ?? null
}

export function saveSettings(patch: Partial<Settings>): void {
  const placeId = getCurrentPlaceId()
  const current = settingsCacheByPlace[placeId] ?? null
  settingsCacheByPlace[placeId] = { ...current, ...patch }
  setDoc(settingsDocRef(placeId), settingsCacheByPlace[placeId]!, { merge: true }).catch(
    (e) => console.error('Firestore saveSettings failed', e),
  )
}

export function isSettingsPrimed(): boolean {
  const placeId = getCurrentPlaceId()
  return placeId in settingsCacheByPlace
}

/** Clear in-memory cache so the next user does not see previous account/place data. */
export function clearSettingsCache(): void {
  Object.keys(settingsCacheByPlace).forEach((k) => delete settingsCacheByPlace[k])
}
